<table class="table">
  <thead>
    <tr>
      <!--<th class="hidden-xs">Action</th>-->
      <th>Building</th>
      <th>Gateway</th>
      <th>Asset</th>
      <th>Received</th>
    </tr>
  </thead>
  <tbody>
    @if (_mode==='charts') {
      <app-dashboard-charts [rows]="rows"></app-dashboard-charts>
    }
    @if (_mode==='realtime') {
      @for (row of rows; track row) {
        <tr class="overview telemetry rag-from-{{row.rag.previous}} rag-{{row.rag.current}}">
          <!--<td class="hidden-xs">
          <span *ngIf="row.action  === 'telemetry'">
            telemetry
          </span>
          <span *ngIf="row.action  === 'rag_change'">
            setpoint
          </span>
        </td> -->
        <td
          [title]="row.action === 'rag_change' ? 'Setpoint change' :  row.action === 'state' ? 'State': 'Telemetry'">
        {{ row.building.title }} </td>
        <td> {{ row.gateway.title }} </td>
        <td>
          @if (row.action === 'rag_change') {
            <span>
              {{ row.asset.title }} ({{row.asset.value}})
            </span>
          }
          @if (row.action === 'state') {
            <span class="red">
              GATEWAY OFFLINE
            </span>
          }
        </td>
        <td title="{{ row.receivedAt | amDateFormat:'HH:MM:ss' }}">
        {{ row.receivedAt | amDateFormat:'HH:mm' }} </td>
      </tr>
      @if (row.action==='telemetry') {
        <tr class="assets  rag-{{row.rag.current}}">
          <td colspan="5">
            @for (asset of row.assets; track asset) {
              <div>
                <div title="{{asset.t}}">{{asset.t}}</div>
                <div title="{{asset.v}}">{{asset.value}}</div>
              </div>
            }
          </td>
        </tr>
      }
    }
  }
  <!-- BUILDINGS -->
  @if (_mode==='buildings') {
    @for (building of buildingService.buildings; track building) {
      <tr>
        <td colspan=5>{{building.title}}</td>
      </tr>
      @for (row of rows; track row) {
        @if (building.id == row.building.id) {
          <tr class="overview building rag-{{row.rag.current}}">
            <!--<td>
            <span *ngIf="row.action  === 'telemetry'">
              telemetry
            </span>
            <span *ngIf="row.action  === 'rag_change'">
              setpoint
            </span>
          </td> -->
          <td colspan="2"> {{ row.gateway.title }} </td>
          <td>
            @if (row.action === 'rag_change') {
              <span>
                {{ row.asset.title }} ({{row.asset.value}})
              </span>
            }
          </td>
          <td> {{ row.receivedAt | amDateFormat:'HH:mm' }} </td>
        </tr>
        @if (row.action==='telemetry') {
          <tr class="assets rag-{{row.rag.current}}">
            <!--<td></td>-->
            <td colspan="4">
              @for (asset of row.assets; track asset) {
                <div>
                  <div title="asset.t">{{asset.t}}</div>
                  <div title="asset.v">{{asset.value}}</div>
                </div>
              }
            </td>
          </tr>
        }
      }
    }
  }
}
</tbody>
</table>
